module.exports = __webpack_public_path__ + "img/uap-100-ans-logo.253709e.png";